import { React, useState, useEffect } from 'react';
import { Editor } from 'draft-js';
import { convertJsonOrStringToContext } from '..';

const ReadonlyEditor = ({ value }) => {
    const [editorState, setEditorState] = useState(null);

    useEffect(() => {
        setEditorState(convertJsonOrStringToContext(value));
    }, [value]);

    if (editorState === null) {
        return null;
    }

    return (
        <>
            <Editor readOnly editorState={editorState} />
        </>
    );
};

export default ReadonlyEditor;
